import classNames from 'classnames';
import DateTime from 'react-datetime';

import FormError from './FormError';

const DatePicker = (props) => {
  const {
    input,
    label,
    meta: { touched, error },
    isValidDate,
    className,
    isOpen,
    required
  } = props;
  if (isOpen) {
    return (
      <div
        className={classNames(
          'c7-search-tools--Date',
          className,
          touched && error && 'c7-error'
        )}
      >
        <DateTime
          onChange={input.onChange}
          value={input.value}
          initialValue={input.value}
          timeFormat={false}
          dateFormat="MMM D, YYYY"
          className="date-picker"
          isValidDate={isValidDate}
          closeOnSelect
          open
          input={false}
          utc
        />
        <FormError touched={touched} error={error} />
      </div>
    );
  }
  return (
    <div
      className={classNames(
        'c7-search-tools--Date',
        className,
        touched && error && 'c7-error'
      )}
    >
      <label htmlFor={label}>
        {/* required && '*' */}
        {label} {!required && <span className="c7-optional">(optional)</span>}
        <DateTime
          onChange={input.onChange}
          value={input.value}
          initialValue={input.value}
          timeFormat={false}
          dateFormat="MMM D, YYYY"
          className="date-picker"
          isValidDate={isValidDate}
          closeOnSelect
          utc
        />
      </label>
      <FormError touched={touched} error={error} />
    </div>
  );
};

export default DatePicker;
